import { z } from 'zod';

/**
 * "Mark as paid" records money already received; "Awaiting payment" places the order unpaid
 * with the chosen manual method's fee and instructions. Limits follow the backend's complete
 * body: reference 200, note 500.
 */
export const completeSchema = z
  .object({
    type: z.enum(['paid', 'manual']),
    manualPaymentMethodId: z.string(),
    reference: z.string().trim().max(200, { error: 'draftOrders:complete.validation.reference' }),
    note: z.string().trim().max(500, { error: 'draftOrders:complete.validation.note' }),
  })
  .refine((v) => v.type !== 'manual' || v.manualPaymentMethodId !== '', {
    path: ['manualPaymentMethodId'],
    error: 'draftOrders:complete.validation.method',
  });

export type CompleteFormInput = z.input<typeof completeSchema>;
export type CompleteFormOutput = z.output<typeof completeSchema>;
